import { Component, OnInit } from '@angular/core';

import { ThingService } from '../thing.service'
import { AwsService } from '../../common/aws.service'
import { MessageService } from '../../messages/message.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
    public confirm: boolean[] = []

    constructor(private thingService: ThingService, private awsService: AwsService, private messageService: MessageService) {
    }

    ngOnInit() {
    }

    public listThings(): any[] {
        return this.thingService.things
    }

    public toNumber(input): number {
        return Number(input)
    }

    public power(thing): void {
        let manualMode: String = '1_60_120'
        if (thing.stateObject && thing.stateObject['mm']) {
            manualMode = thing.stateObject['mm']
            let params: string[] = manualMode.split('_')
            let power: number = (Number(params[0]) === 1) ? 0 : 1
            manualMode = power + '_' + params[1] + '_' + params[2]
        }

        let payload: any = {}
        payload.state = {}
        payload.state.desired = {}
        payload.state.desired['mm'] = manualMode
        this.thingService.updateShadow(thing.name, payload)
    }

    // -1 = state not available, 0 = off, 1 = on
    public deviceOn(thing): number {
        if (!thing || !thing.stateObject || thing.stateObject.pr1 === undefined) {
            return -1
        }
        let pr1Value: number = Number(thing.stateObject.pr1)
        return pr1Value === 255 ? 0: 1
    }

    public toValue(input) {
        if (input === undefined) {
            return '-'
        }
        return input
    }

    public checkWarning(thing): any {
        return {
            t1: thing && thing.stateObject && thing.stateObject.t1 >= 100,
            t2: thing && thing.stateObject && thing.stateObject.t2 >= 100
        }
    }

    public saveName(event, thing): void {
        // could update label right away, and rollback previous value if save fails
        this.awsService.getApiClient()
            .then((apiClient) => this.namesPost(apiClient, thing, event))
            .then(() => {
                thing.label = event
                this.thingService.sortThings()
            })
            .catch((error) => {
                console.log('dashboard.saveName error', error)
                this.messageService.warning('dashboard.failed_to_save_device_name')
            })
    }

    private namesPost(apiClient, thing, name): Promise<any> {
        var params = {
            headers: {
                'Content-type': 'application/json'
            }
        }
        var body = {
            thingName: thing.name,
            name: name
        }
        var additionalParams = {}
        return apiClient.namesPost(params, body, additionalParams)
    }

    public removeDevice(thing): void {
        this.confirm[thing.name] = false
        this.awsService.getApiClient()
            .then((apiClient) => {
                return this.removeDevicePost(apiClient, thing.name)
            })
            .then(() => {
                return this.thingService.initialize(true)
            })
            .catch((error) => {
                console.log('remove-device API NOK', error)
                if (error && error.status && error.status === 400) {
                    // TODO send message key values from api (or use some generic error?)
                    this.messageService.warning(error.data.message)
                }
            })
    }

    public cancelRemoveDevice(thing): void {
        this.confirm[thing.name] = false
    }

    private removeDevicePost(apiClient, thingName) {
        var params = {
            headers: {
                'Content-type': 'application/json'
            }
        }
        var body = {
            thingName: thingName
        }
        var additionalParams = {}
        return apiClient.removeDevicePost(params, body, additionalParams)
    }
}



// WEBPACK FOOTER //
// /Users/mjahoo/workspace/rento/git/saunasampo-monitor/src/app/device/dashboard/dashboard.component.ts